import { HealthData, HealthCheckMode } from './types';

// Health check state
let isHealthy: boolean | null = null;
let checking = false;
let lastCheckTime = 0;
let healthData: HealthData | null = null;
let currentMode: HealthCheckMode = 'standard';
let lastRequestTimestamp: number | null = null;
let lastResponseTime: number | null = null;

// Set of registered listeners to notify of changes
const listeners: Set<() => void> = new Set();

export const healthStore = {
  // Basic state getters
  getHealthStatus: (): boolean | null => isHealthy,
  isChecking: (): boolean => checking,
  getLastCheckTime: (): number => lastCheckTime,
  getHealthData: () => healthData,
  getMode: () => currentMode,
  getLastRequestTimestamp: () => lastRequestTimestamp,
  getLastResponseTime: () => lastResponseTime,
  
  // Update methods
  setHealthStatus: (status: boolean): void => { 
    isHealthy = status;
    notifyListeners();
  },
  setIsChecking: (status: boolean): void => { 
    checking = status;
    notifyListeners(); 
  },
  setLastCheckTime: (time: number): void => { 
    lastCheckTime = time;
  },
  setHealthData: (data: HealthData | null): void => { 
    healthData = data;
    notifyListeners();
  },
  setMode: (mode: HealthCheckMode): void => {
    currentMode = mode;
  },
  setLastRequestTimestamp: (timestamp: number | null): void => {
    lastRequestTimestamp = timestamp;
  },
  setLastResponseTime: (time: number | null): void => {
    lastResponseTime = time;
    notifyListeners();
  },
  
  // Listener registration
  subscribe: (callback: () => void): (() => void) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },
  
  // Reset state (useful when logging out)
  reset: () => {
    isHealthy = null;
    checking = false;
    lastCheckTime = 0;
    healthData = null;
    lastRequestTimestamp = null;
    lastResponseTime = null;
    notifyListeners();
  }
};

// Notify all registered listeners of state changes
function notifyListeners() {
  listeners.forEach(listener => listener());
}
